import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import DtcMappingRows from './DtcMappingRows'
import { postRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'

const DtcMappingItem = (props) => {
  const [navState, navDispatch] = useContext(NavContext)
  const { name, ecu, mappings, circuits, id, onDtcMappingChange, description } =
    props

  const deleteMapping = async (mapping_id, category, name) => {
    if (
      window.confirm(`Are you sure want to delete mapping ${name}`) === true
    ) {
      let res = await postRequest(`/api/dtcs/clear_mappings/`, {
        category: category,
        id: mapping_id,
        dtc_id: id,
        name: name,
      })
      if (res?.errors < 1) {
        onDtcMappingChange()
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `${name ? name : ''} ${category} ${
              ['Start', 'End'].includes(category) && 'Connector'
            } Deleted Successfully !`,
          },
        })
      }
    }
  }

  return (
    <div className="bg-white w-full py-2 pl-1 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row">
        <div className="w-12 font-bold text-sm">DTC: </div>
        <div className="w-5/6">
          <div className="group hover:bg-blue-100 cursor-pointer">
            <div className="group flex justify-between">
              <span className="font-bold">{name}</span>
              <a
                onClick={() => {
                  deleteMapping('', 'clear_all', name)
                }}
                className="text-red-500 underline group-hover:visible invisible cursor-pointer "
                rel={'nofollow'}
                data-method={'delete'}
                data-confirm={'Are you sure?'}
              >
                Clear Mappings
              </a>
            </div>
            <div className="text-xs">{description}</div>
          </div>
        </div>
      </div>

      <div className="flex flex-row">
        <div className="w-12 font-bold text-sm">ECU: </div>
        <div className="font-bold">{ecu}</div>
      </div>
      <DtcMappingRows
        mappings={mappings?.start}
        category="Start"
        deleteMapping={(id, category, name) =>
          deleteMapping(id, category, name)
        }
      />
      <DtcMappingRows
        mappings={mappings?.end}
        category="End"
        deleteMapping={(id, category, name) =>
          deleteMapping(id, category, name)
        }
      />
      <DtcMappingRows
        mappings={mappings?.devices}
        category="Devices"
        deleteMapping={(id, category, name) =>
          deleteMapping(id, category, name)
        }
      />
      <DtcMappingRows
        mappings={circuits}
        category="Circuits"
        deleteMapping={(id, category, name) =>
          deleteMapping(id, category, name)
        }
      />
    </div>
  )
}

DtcMappingItem.propTypes = {
  name: PropTypes.string.isRequired,
  ecu: PropTypes.string.isRequired,
  mappings: PropTypes.object.isRequired,
  circuits: PropTypes.array.isRequired,
}

export default DtcMappingItem
